import React, { useState } from 'react';

// Config and data
import { onlineCityCode } from '~/data/fakeCities'; // its not fake, its real

import Card from '~/components/popups/Card';

const CoursePlaybillContent = props => {

  const [cardIdCalendarClicked, setCardIdCalendarClicked] = useState();

  const cards = props.data.map(c => {
    return <Card key={c.id} {...c} />;
  });

  const emptyResult = (
    <p className="txt empty-result">Мы не нашли программ по таким фильтрам.</p>
  );

  const renderedCards = props.data
    .filter(
      c =>
        (c.CITY && c.CITY.NAME == props.city) || c.CITY_CODE == onlineCityCode,
    )
    .map(c => {
      return (
        <Card
          key={c.id}
          isRegPopup
          setCardIdCalendarClicked={setCardIdCalendarClicked}
          cardIdCalendarClicked={cardIdCalendarClicked}
          {...c}
        />
      );
    });

  // If city is not moscow, append moscow events
  const appendedCards =
    props.city === 'Москва'
      ? []
      : props.data
        .filter(c => c.CITY && c.CITY.NAME == 'Москва')
        .map(c => <Card key={c.id} {...c} />);

  const appendedHtml =
    appendedCards.length > 0
      ? (
        <React.Fragment>
          <h5 className="txt appended-events-title">Также в Москве:</h5>
          <div className="course-reg">{appendedCards}</div>
        </React.Fragment>
      ) : null;

  return (
    <React.Fragment>
      <div className="course-reg">{renderedCards.length ? renderedCards : emptyResult}</div>
      {/*
				FIXME
				Данный блок скрыт на время тестов мероприятий доступных только для
				конкретного региона
				{appendedHtml}
				*/}
    </React.Fragment>
  );
};

export default CoursePlaybillContent;
